import {
  ChangeDetectionStrategy,
  Component,
  computed,
  effect,
  inject,
  OnDestroy,
  Renderer2,
  viewChild,
} from "@angular/core";
import { Dialog, DialogModule } from "primeng/dialog";
import { PrimeTemplate } from "primeng/api";
import { ScreenWidthService } from "@platform-app/app/shared/common/services/screen-width.service";
import { RendererUtility } from "@platform-app/app/shared/common/utilities";
import { DeviceSupportService } from "@platform-app/app/shared/common/services/device-support.service";

@Component({
  selector: "app-screen-notification",
  standalone: true,
  imports: [DialogModule, PrimeTemplate],
  templateUrl: "./screen-notification.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScreenNotificationComponent implements OnDestroy {
  private readonly renderer = inject(Renderer2);
  private readonly deviceSupportService = inject(DeviceSupportService);
  private readonly screenWidthService = inject(ScreenWidthService);

  dialog = viewChild(Dialog);

  isDialogOpened = computed(
    () => this.isMobile() && !this.deviceSupportService.isMobileSupported(),
  );

  private isMobile = this.screenWidthService.isMobile;

  constructor() {
    effect(() => {
      if (this.isDialogOpened() && this.dialog()) {
        RendererUtility.applyScrollLock(this.renderer);
        this.dialog()!.maximized = true;
      } else {
        RendererUtility.removeScrollLock(this.renderer);
      }
    });
  }

  ngOnDestroy(): void {
    RendererUtility.removeScrollLock(this.renderer);
  }
}
